import template   from './input-tooltip.html'
import controller from './input-tooltip.controller'
import './input-tooltip.styl'

let component = {
  restrict: 'E',
  bindings: {
    text: '@',
    name: '@'
  },
  controller,
  template
}

export default component



// WEBPACK FOOTER //
// ./src/app/common/input-tooltip/input-tooltip.component.js